import 'core-js/es6/promise';
import 'core-js/fn/array/find';
import 'core-js/fn/array/includes';
import 'core-js/fn/string/includes';
import URLSearchParams from 'url-search-params';

// Need this to make var available everywhere
global.URLSearchParams = URLSearchParams;

// Applying function.call fix for Microsoft Edge <= 14
/* eslint-disable */
if (
  window &&
  window.navigator &&
  window.navigator.userAgent &&
  /Edge\/1[0-4]\./.test(window.navigator.userAgent)
) {
  // Fix for bug in Microsoft Edge: https://github.com/Microsoft/ChakraCore/issues/1415#issuecomment-246424339
  Function.prototype.call = function(t) {
    return this.apply(t, Array.prototype.slice.apply(arguments, [1]));
  };
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/util/polyfill.js